import { createFileRoute, redirect } from "@tanstack/react-router"

import { routeGuard } from "@/lib/routing/beforeLoad"
import { getNetworkConfigPermissionFlag } from "@/lib/utils/device"

export const Route = createFileRoute("/_authlayout/_header/devices/$id/networkconfig/")({
  beforeLoad: async ({ context }) => {
    await routeGuard(context)
  },
  loader: async ({ context, params }) => {
    // A bare `query()`, not `staleTime: "static"`: the `$id` route validates
    // with the same key, so this dedupes onto its in-flight fetch instead of
    // resolving to a stale copy. The rejection is swallowed on purpose — that route owns
    // validation, and an error escaping here would surface a raw API error ahead
    // of its `notFound()`.
    const device = await context.queryClient.query(context.deviceQueryOptions).catch(() => undefined)
    if (!device) return

    await routeGuard(context, {
      permission: {
        flag: getNetworkConfigPermissionFlag(device),
        fallbackRoute: { to: "/devices/$id", params: { id: params.id } }
      }
    })

    if (!device.unique_hardware_id && !device.thing?.sketch_id) {
      throw redirect({
        to: `/devices/$id`,
        params: { id: params.id }
      })
    }
  }
})
